import React from "react";
import {Form, Button, Container, Row, Col} from 'react-bootstrap';
import './Home.css';
import axios from "axios"
import { useEffect, useState } from 'react';
import MainDisplay from "./MainDisplay";
import Corosel from "./Corosel";
import Pagination from "./Pagination"
import Jumbotron from "./Jumbotron";
import Jumbo from "./Jumbo";

const Home = () => {
    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState("");    
    const [query, setQuery] = useState("");
    const [currentPage, setCurrentPage] = useState("1");
    const [productsPP] = useState("10");

    useEffect(()=>{
    getproduct();
    }, [query]);
        
        const getproduct = async () => {
        const response = await axios.get(`https://bukapi123.herokuapp.com/products?productName=${query}`);
        const data = response.data
        setProducts(data)
        console.log(data)
    }

    const updateSearch = e => {
        setSearch(e.target.value);
        console.log(search);
    };

    const getSearch = e => {
    e.preventDefault();
    setQuery(search);
    setSearch("");
    };

    //Get current product
    const indexOfLastProduct = currentPage*productsPP;
    const indexOfFirstProduct = indexOfLastProduct - productsPP
    const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);

    //Change page
    const paginate = pageNumber => setCurrentPage(pageNumber);
    
    return (
        <div>
        <Container fluid>
            <Row>
              <Col>
                <div>
                  <Corosel/>
                </div>
             </Col>   
            </Row>
           <Row>
             <Col><span>     
               <Jumbotron/>
             </span> 
             </Col>
             <Col><span>     
               <Jumbo/>
             </span> 
             </Col>
           </Row>
            <Row>

                 <Col md={{ span: 6, offset: 3 }}>
                 <div ClassName="col">
             <Form onSubmit={getSearch} ClassName="form">
             <Form.Group controlId="formBasicEmail">
                 <Form.Label>Product Search</Form.Label>
                      <Form.Control type="text" placeholder="Type Product Name" value={search} onChange={updateSearch}/>
                          <Form.Text className="text-muted">
                          <span className="style">Please type the name of the Product you want and Submit</span>
                          </Form.Text>
            </Form.Group>

            <Button variant="primary" type="submit">
                 Submit
           </Button>
           </Form>
           </div>
        </Col>
        </Row>
        
        <Row>
        <Col md={12}>
        <div className="horizontal">
        {currentProducts.map(
            (product) => 
            <MainDisplay
            key={product.product_id} 
            productImage={product.productImage}
            productName={product.productName}
            description={product.description}
            price={product.price}
            /> 
            
        )}
        </div>
        <div>
        <Pagination productsPP={productsPP} totalProducts={products.length} paginate={paginate}/>
        </div>
        </Col>
        </Row>
       
       
        </Container>
        </div>
    )
    }

export default Home
